module.exports = __webpack_public_path__ + "assets/2f593fc951a23a014fe03d03690b7cb9.mp4";